import Vue from 'vue';
const resource = '/orderreceptions';

export default {
  // CUSTOM ENDPOINT
  getByOrder(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`orders/${idPublic}${resource}`);
  },
};
